'use strict';

export default [
    '$resource',
    ($resource) => $resource(null, null, {
        // Показатель "Количество проектов в разрезе отраслевых принадлежностей"
        countByIndustry: {
            url: 'api/metrics/projects/count-by-industry',
            method: 'POST',
            isArray: true,
        },
        // Показатель "Количество проектов в разрезе статусов проектов"
        countByStatus: {
            url: 'api/metrics/projects/count-by-status',
            method: 'POST',
            isArray: true,
        },
        // Показатель "Количество проектов в разрезе этапов"
        countByPhase: {
            url: 'api/metrics/projects/count-by-phase',
            method: 'POST',
            isArray: true,
        },
        // Показатель "Количество проектов в разрезе муниципальных образований"
        countByMunicipality: {
            url: 'api/metrics/projects/count-by-municipality',
            method: 'POST',
            isArray: true,
        },
        // Показатель "Требуемые и фактические (предоставленные) ресурсы в разрезе типов ресурсов"
        resourceSupport: {
            url: 'api/metrics/projects/resource-support',
            method: 'POST',
            isArray: true,
        },
        // Показатель "Общий объем инвестиций (Фактический)"
        factFund: {
            url: 'api/metrics/projects/fact-fund',
            method: 'POST',
        },
        // Показатель "Общий объем инвестиций (Плановый)"
        planFundsTotal: {
            url: 'api/metrics/projects/plan-funds-total',
            method: 'POST',
        },
        // Показатель "Финансирование в разрезе категорий финансирования"
        factFundBySrcCategory: {
            url: 'api/metrics/projects/fact-fund-by-src-category',
            method: 'POST',
            isArray: true,
        },
        // Показатель "Количество планируемых и созданных рабочих мест"
        workPlace: {
            url: 'api/metrics/projects/work-place',
            method: 'POST',
        },
        // Показатель "Количество рабочих мест в разрезе типов"
        workPlaceByGroup: {
            url: 'api/metrics/projects/work-place-by-group',
            method: 'POST',
            isArray: true,
        },
        // Показатель "Налоги в разрезе видов налогов"
        tax: {
            url: 'api/metrics/projects/tax',
            method: 'POST',
            isArray: true,
        },
        // Показатель "Налоги в разрезе кварталов и годов"
        taxByQuarter: {
            url: 'api/metrics/projects/tax-by-quarter',
            method: 'POST',
            isArray: true,
        },
        // Рабочие места в разрезе кварталов
        workPlaceByQuarter: {
            url: 'api/metrics/projects/work-place-by-quarter',
            method: 'POST',
            isArray: true,
        },
        // Фактические инвестиции по кварталам
        factFundByQuarter: {
            url: 'api/metrics/projects/fact-fund-by-year',
            method: 'POST',
            isArray: true,
        },
        // Фактические инвестиции по кварталам
        planFundByQuarter: {
            url: 'api/metrics/projects/plan-fund-by-year',
            method: 'POST',
            isArray: true,
        },

        projectsByManagers: {
            url: '/api/metrics/projects/count-by-manager',
            method: 'POST',
            isArray: true,
        },

        projectsByRisk: {
            url: ' /api/metrics/projects/risks',
            method: 'POST',
        },

        fundByIndustry: {
            url: ' /api/metrics/projects/fund-by-industry',
            method: 'POST',
            isArray: true,
        },

        projectByOiv: {
            url: ' /api/metrics/projects/project-by-oiv',
            method: 'POST',
            isArray: true,
        },

        projectByType: {
            url: ' /api/metrics/projects/project-by-type',
            method: 'POST',
            isArray: true,
        },

        workPlaceByIndustry: {
            url: ' /api/metrics/projects/work-place-by-industry',
            method: 'POST',
            isArray: true,
        },

        fundsByMunicipality: {
            url: ' /api/metrics/projects/funds-by-municipality',
            method: 'POST',
            isArray: true,
            params: { municipalityId: '@municipalityId' },
        },
    }),
];
